module.exports = __webpack_public_path__ + "static/img/img_logo.ab371d00.png";